/** Canonical app timezone used for every date/time displayed in the ERP. */
export const APP_TIMEZONE = 'Asia/Kolkata' as const;

const dateFormatter = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: '2-digit', year: 'numeric', timeZone: APP_TIMEZONE,
});

const dateTimeFormatter = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true, timeZone: APP_TIMEZONE,
});

/** Formats any parseable date input as DD/MM/YYYY (e.g. 24/08/2026). */
export const formatDate = (value: string | number | Date): string => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateFormatter.format(date);
};

/** Formats any parseable date input as DD/MM/YYYY, hh:mm am/pm (e.g. 24/08/2026, 09:30 am). */
export const formatDateTime = (value: string | number | Date): string => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateTimeFormatter.format(date);
};
